type LinkObjectProps = {
    url: string;
    name: string;
};

export default class LinkObject {
    url: string;

    name: string;

    constructor({ url, name }: LinkObjectProps) {
        this.url = url;
        this.name = name;
    }
}
